import { Stack, Text } from '@mantine/core';
import Lottie from 'lottie-react';
import animationData from './NoResults.json';

export interface AfaMessageAnimeProps {
  /**
   * Título del mensaje
   */
  title?: string;
  /**
   * Descripción del mensaje
   */
  description?: string;
  /**
   * Clase CSS adicional
   */
  className?: string;
  /**
   * Estilos inline
   */
  style?: React.CSSProperties;
}

const AfaMessageAnime = ({ 
  title,
  description,
  className,
  style,
}: AfaMessageAnimeProps) => {
  return (
    <Stack 
      gap={4} 
      align="center" 
      {...(className && { className })}
      {...(style && { style })}
    >
      {/* Animación Lottie */}
      <div style={{ width: 56, height: 56 }}>
        <Lottie 
          animationData={animationData}
          loop={true}
          autoplay={true}
          style={{ width: '100%', height: '100%' }}
        />
      </div>

      {/* Título - mismo estilo que AfaAlert title */}
      {title && (
        <Text 
          size="sm" 
          fw={700}
          style={{ 
            lineHeight: 1.4,
            textAlign: 'center'
          }}
        >
          {title}
        </Text>
      )}

      {/* Descripción - mismo estilo que AfaAlert body */}
      {description && (
        <Text 
          size="sm"
          style={{ 
            lineHeight: 1.4,
            textAlign: 'center'
          }}
        >
          {description}
        </Text>
      )}
    </Stack>
  );
};

export default AfaMessageAnime;
